<template>
  <div class="text-13 text-gray-700 flex items-center gap-x-1 w-full min-w-0">
    <span class="font-500 flex-shrink-0">Flow:</span>
    <span class="truncate">{{ flowName || 'Not configured' }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'FlowInvokeOverview',
  props: {
    item: Object,
  },
  computed: {
    ...mapGetters(['getProjectFlows']),
    flowName() {
      const flowId = this.item?.payload?.flow_id;
      if (!flowId) return '';
      return this.getProjectFlows()?.[flowId]?.name || flowId;
    },
  },
};
</script>
